import TabsBar from './TabsBar';

export default TabsBar;
